import React from "react";
import PatientDetails from "../../pages/Patient/PatientDetails";

function NewPatient() {
  return <PatientDetails newPatient={true} />;
}

export default NewPatient;
